import {FaAward} from 'react-icons/fa'
import {TbBooks} from 'react-icons/tb'
import {BiHappyHeartEyes} from 'react-icons/bi'

const data = [
    {id: 1, icon: <FaAward/>, title: 'Experience', desc: '5+ Years Coding'},
    {id: 2, icon: <TbBooks/>, title: 'Projects', desc: '6 Major Completed'},
    {id: 3, icon: <BiHappyHeartEyes/>, title: 'Nexus Mods', desc: '13,000+ Total Downloads'}
]

export default data;